/**
 * billingKey 즉시 청구 요청(구독 완성·좌석 추가·재활성화)의 대기 한도.
 *
 * 게이트웨이 한도(`BILLING_KEY_PROXY_TIMEOUT_MS`, 100s)보다 **길어야** 한다. 짧으면 화면이 먼저
 * 포기해 성사된 결제가 실패로 보이고, 고객은 다시 결제한다.
 */
export const BILLING_KEY_CHARGE_TIMEOUT_MS = 110_000;
